import {useMutation} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface UseClosePullRequestArgs {
  repoNwo?: string
  prNumber?: number
}

export function useClosePullRequest({repoNwo, prNumber}: UseClosePullRequestArgs) {
  return useMutation({
    mutationKey: ['closePullRequest', repoNwo, prNumber],
    mutationFn: async () => {
      if (!repoNwo || !prNumber) {
        throw new Error('Missing required repoNwo or prNumber to close pull request')
      }
      const response = await verifiedFetchJSON(`/${repoNwo}/pull/${prNumber}/page_data/close_pull_request`, {
        method: 'POST',
      })
      if (!response.ok) {
        throw new Error('Failed to close pull request')
      }
      return response
    },
  })
}
